import styled from '@emotion/styled';

import { SBox as Box } from '@skippay/core/components/Box/Box.styled';
import { BOOTSTRAP_BREAKPOINTS, media } from '@skippay/core/styles/media';
import { size } from '@skippay/core/styles/spacing';
import { color, fontSize, fontWeight, radius } from '@skippay/core/styles/variables';
import { shouldForwardProp } from '@skippay/core/utils/emotionUtils';

const horizontalSpacingSm = { mobile: size(6), desktop: size(6) };
const horizontalSpacingLg = { mobile: size(3), desktop: size(8) };

export const SBox = styled(Box, {
	shouldForwardProp: (prop) => shouldForwardProp(['boxSize', 'disabled'], prop),
})<{ boxSize: 'sm' | 'lg'; disabled?: boolean }>`
	width: 100%;
	max-width: ${({ boxSize }) => (boxSize === 'lg' ? size(160) : size(100))};
	padding: ${({ boxSize }) =>
		boxSize === 'lg'
			? `${size(8)} ${horizontalSpacingLg.mobile} ${size(6)}`
			: `${size(12)} ${horizontalSpacingSm.mobile} ${size(5)}`};
	margin: 0 auto;
	opacity: ${({ disabled }) => (disabled ? 0.7 : 1)} @media
		(max-width: ${BOOTSTRAP_BREAKPOINTS.SM}px) {
		border: none !important;
	}
	@media ${media.gt('MD')} {
		padding: ${({ boxSize }) =>
			boxSize === 'lg'
				? `${size(12)} ${horizontalSpacingLg.desktop} ${size(8)}`
				: `${size(12)} ${horizontalSpacingSm.desktop} ${size(5)}`};
	}
`;

export const SBadge = styled('div', {
	shouldForwardProp: (prop) => shouldForwardProp(['spacing'], prop),
})<{ spacing: 'sm' | 'lg' }>`
	position: absolute;
	left: ${horizontalSpacingSm.mobile};
	top: 0;
	transform: translateY(-50%);
	padding: 2px ${size(2)};
	border-radius: ${radius('large')};
	background-color: ${color('blue-500')};
	font-size: ${fontSize('xs')};
	font-weight: ${fontWeight('strong')};
	color: ${color('white')};
	text-align: center;
	white-space: nowrap;
	@media ${media.gt('MD')} {
		left: ${({ spacing }) =>
			spacing === 'lg' ? horizontalSpacingLg.desktop : horizontalSpacingSm.desktop};
	}
`;

export const SLine = styled.div`
	position: relative;
	width: 100%;
	max-width: ${size(34)};
	margin: 0 auto;
	background: ${color('light-gray-200')};
	height: 1px;
`;

export const SLineText = styled.div`
	width: ${size(10)};
	text-align: center;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	background: ${color('white')};
	.dark & {
		background: ${color('gray-50', 'dark')};
	}
`;
